import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      marginBottom: 28,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 29,
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 40,
      },
    },
    title: {
      textAlign: "center",
      marginBottom: 11,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 14,
      },
      [theme.breakpoints.up("tablet")]: {
        textAlign: "left",
        marginBottom: 20,
      },
    },
  }),
  { name: "FeaturedClips" },
);
